import { AppRouteProps } from "@bsm/component";
import React from "react";

const InvoiceCreate = React.lazy(() => import("./container/InvoiceCreate"))

export const InvoiceCreateRoute = [
    {
        path: "create",
        element: <InvoiceCreate />
    }
] as Array<AppRouteProps>